let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jJdZ4")).then(() => parcelRequire('KN7Dc'));